/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_New_Version_TitleInputs */

const en_app_new_version_title = /** @type {(inputs: App_New_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version is available`)
};

const pt_br2_app_new_version_title = /** @type {(inputs: App_New_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova versão disponível`)
};

/**
* | output |
* | --- |
* | "A new version is available" |
*
* @param {App_New_Version_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const app_new_version_title = /** @type {((inputs?: App_New_Version_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_New_Version_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_new_version_title(inputs)
	return pt_br2_app_new_version_title(inputs)
});